import { Action, Reducer } from 'redux';
import {
  PositionState,
  PositionTypes,
  PositionActionTypes
} from './positionTypes';
import {
  haskeyReducer,
  resetIsolatedReducer,
  updateGetIsolated,
  updateSaveIsolated
} from '@/main/services/reducerUtils';

export const INITIAL_STATE: PositionState = {
  position: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  isolated: {}
};

const positionReducer: Reducer<PositionState> = (
  state: PositionState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as PositionActionTypes;
  switch (actionTypes.type) {
    case PositionTypes.GET_POSITION:
      const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducer) return updateGetIsolated(state, actionTypes);

      return {
        ...state,
        position: { ...state.position, isLoading: true }
      };
    case PositionTypes.GET_POSITION_IDPIES:
      const isKeyReducerPIES = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerPIES) return updateGetIsolated(state, actionTypes);

      return {
        ...state,
        position: { ...state.position, isLoading: true }
      };
    case PositionTypes.SAVE_POSITION:
      const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);
      return {
        ...state,
        position: {
          ...state.position,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case PositionTypes.RESET_REDUCER_POSITION:
      const isKeyReducerReset = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerReset) return resetIsolatedReducer(state, actionTypes);

      return {
        ...state,
        position: INITIAL_STATE.position
      };
    default:
      return state;
  }
};

export default positionReducer;

